import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import ActivitiesField from '../../components/ActivitiesField';
import store from '../../redux';

/** Class representing a Activities selector field. */
class ActivitiesSelectorField extends TextField {

    constructor(properties) {
        super({
            ...(ActivitiesSelectorField.getDefaultOptions()),
            ...properties,
            name: 'activities'
        });

        this.type = FormLayout.ACTIVITIES;

        // sort choices by ascending position
        this.choices = (this.choices || []).sort((a, b) => a.position - b.position);
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();

        properties.name     = 'activities';
        properties.choices  = [];
        properties.expanded = false;
        properties.required = true;
        properties.multiple = true;

        return properties;
    }

    /**
     * Get choices refs, if any
     *
     * Refs are used to propose linked resources as choices,
     * like the activities or abilities for example
     */
    getRefs() {
        const activities = store?.getState()?.activities?.activities || [];
        return activities?.map(activity => ({
            id: activity.id,
            name: activity.name,
        }));
    }

    /**
     * Get choices refs source, if any
     *
     * Refs are used to propose linked resources as choices,
     * like the activities or abilities for example
     */
    getRefsSource() {
        return 'activities';
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return [
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_LABEL,
            FormLayout.OPTION_DESCRIPTION,
            FormLayout.OPTION_CHOICES,
        ];
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        let activities = props.resources?.activities;
        if (!activities?.length) {
            activities = (store?.getState()?.activities?.activities || []);
        }
        const activity_ids = this.choices?.map(choice => choice.ref_id);
        activities = activities.filter(activity => activity_ids.includes(activity.id));

        return (
            <ActivitiesField
                activities={activities}
                name={this.reduxFieldName(props)}
                preventSubmit
            />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'address-book';
    }
}

export default ActivitiesSelectorField;
